import React from 'react';
import ComplianceHealthWidget from '../../components/widgets/ComplianceHealthWidget';
import ISMSObjectivesListWidget from '../../components/widgets/ISMSObjectivesListWidget';
import AssuranceHealthWidget from '../../components/widgets/AssuranceHealthWidget';
import UpcomingTasksWidgetMediumTall from '../../components/widgets/UpcomingTasksWidgetMediumTall';
import OverdueTasksWidgetMediumTall from '../../components/widgets/OverdueTasksWidgetMediumTall';
import RiskHeatMapWidget from '../../components/widgets/RiskHeatMapWidget';
import DataStorageMapWidget from '../../components/widgets/DataStorageMapWidget';
import SupplyChainRisksChartWidget from '../../components/widgets/SupplyChainRisksChartWidget';
import DataFlowDiagram from '../../components/widgets/DataFlowDiagram';
import TaskAssignmentListWidget from '../../components/widgets/TaskAssignmentListWidget';
import DaysUntilNextExternalAuditDateWidget from '../../components/widgets/DaysUntilNextExternalAuditDateWidget';
import TotalRisksCountWidget from '../../components/widgets/TotalRisksCountWidget';
import UsersWithIncompleteReadingCountWidget from '../../components/widgets/UsersWithIncompleteReadingCountWidget';
import OverdueTasksCounterWidget from '../../components/widgets/OverdueTasksCounterWidget';
import OnTimePerformanceWidget from '../../components/widgets/OnTimePerformanceWidget';
import TotalSupplierCountWidget from '../../components/widgets/TotalSupplierCountWidget';
import OverallProgressCard from '../../components/onboarding/StepTrackingCard';
import StepTrackingCard from '../../components/onboarding/OverallProgressCard';
// import OpenNonConformitiesCountWidget from '../../components/widgets/OpenNonConformitiesCountWidget';
import SupportingDocsRequiresAttentionWidget from '../../components/widgets/SupportingDocsRequiresAttentionWidget';
import CorrectiveActionsSummaryWidget from '../../components/widgets/CorrectiveActionsSummaryWidget';
import CorrectiveActionsListWidget from '../../components/widgets/CorrectiveActionsListWidget';
// import RFFRControlsImplementedWidget from '../../components/widgets/RFFRControlsImplementedWidget';
// import RFFRControlsFullyImplementedWidget from '../../components/widgets/RFFRControlsFullyImplementedWidget';
// import RFFRControlsPartiallyImplementedWidget from '../../components/widgets/RFFRControlsPartiallyImplementedWidget';
// import RFFRControlsNotImplementedWidget from '../../components/widgets/RFFRControlsNotImplementedWidget';
// import RFFRControlsNotApplicableWidget from '../../components/widgets/RFFRControlsNotApplicableWidget';
// import RFFRControlsNotAssessedWidget from '../../components/widgets/RFFRControlsNotAssessedWidget';

interface DashboardWidget {
  id: string;
  component: React.ComponentType<any>;
  props: Record<string, any>;
}

// Dashboard widget layout/config. Add or reorder widgets as needed.
const dashboardConfig: DashboardWidget[] = [
  {
    id: "compliance-health",
    component: ComplianceHealthWidget,
    props: {},
    "h": 3,
    "i": "compliance-health",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 0,
    "y": 0
  },
  {
    id: "isms-objectives",
    component: ISMSObjectivesListWidget,
    props: {},
    "h": 3,
    "i": "isms-objectives",
    "moved": false,
    "static": false,
    "w": 6,
    "x": 3,
    "y": 0
  },
  {
    id: "assurance-health",
    component: AssuranceHealthWidget,
    props: {},
    "h": 3,
    "i": "assurance-health",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 6,
    "y": 6
  },
  {
    id: "upcoming-tasks",
    component: UpcomingTasksWidgetMediumTall,
    props: {},
    "h": 3,
    "i": "upcoming-tasks",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 9,
    "y": 6
  },
  {
    id: "overdue-tasks",
    component: OverdueTasksWidgetMediumTall,
    props: {},
    "h": 6,
    "i": "overdue-tasks",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 9,
    "y": 0
  },
  {
    id: "risk-heatmap",
    component: RiskHeatMapWidget,
    props: {},
    "h": 3,
    "i": "risk-heatmap",
    "moved": false,
    "static": false,
    "w": 6,
    "x": 3,
    "y": 3
  },
  {
    id: "data-storage-map",
    component: DataStorageMapWidget,
    props: {},
    "h": 5,
    "i": "data-storage-map",
    "moved": false,
    "static": false,
    "w": 6,
    "x": 3,
    "y": 13
  },
  {
    id: "supply-chain-risks",
    component: SupplyChainRisksChartWidget,
    props: {},
    "h": 4,
    "i": "supply-chain-risks",
    "moved": false,
    "static": false,
    "w": 6,
    "x": 6,
    "y": 9
  },
  {
    id: "data-flow-diagram",
    component: DataFlowDiagram,
    props: {},
    "h": 4,
    "i": "data-flow-diagram",
    "moved": false,
    "static": false,
    "w": 6,
    "x": 0,
    "y": 9
  },
  {
    id: "task-assignment",
    component: TaskAssignmentListWidget,
    props: {},
    "h": 3,
    "i": "task-assignment",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 3,
    "y": 6
  },
  {
    id: "next-audit",
    component: DaysUntilNextExternalAuditDateWidget,
    props: {},
    "h": 3,
    "i": "next-audit",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 6,
    "y": 18
  },
  {
    id: "total-risks",
    component: TotalRisksCountWidget,
    props: {},
    "h": 3,
    "i": "total-risks",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 9,
    "y": 13
  },
  {
    id: "incomplete-readings",
    component: UsersWithIncompleteReadingCountWidget,
    props: {},
    "h": 3,
    "i": "incomplete-readings",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 3,
    "y": 18
  },
  {
    id: "overdue-counter",
    component: OverdueTasksCounterWidget,
    props: {},
    "h": 3,
    "i": "overdue-counter",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 0,
    "y": 6
  },
  {
    id: "on-time-performance",
    component: OnTimePerformanceWidget,
    props: {},
    "h": 3,
    "i": "on-time-performance",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 0,
    "y": 16
  },
  {
    id: "supplier-count",
    component: TotalSupplierCountWidget,
    props: {},
    "h": 3,
    "i": "supplier-count",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 0,
    "y": 13
  },
  {
    id: "docs-requires-attention",
    component: SupportingDocsRequiresAttentionWidget,
    props: {},
    "h": 3,
    "i": "docs-requires-attention",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 0,
    "y": 3
  },
  {
    id: "corrective-actions-summary",
    component: CorrectiveActionsSummaryWidget,
    props: {},
    "h": 3,
    "i": "corrective-actions-summary",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 9,
    "y": 18
  },
  {
    id: "corrective-actions-list",
    component: CorrectiveActionsListWidget,
    props: {},
    "h": 3,
    "i": "corrective-actions-list",
    "moved": false,
    "static": false,
    "w": 3,
    "x": 0,
    "y": 21
  }
];


const PA_dashboardConfig: DashboardWidget[] = [

    {
      id: "compliance-health",
      component: ComplianceHealthWidget,
      props: {},
      "h": 3,
      "i": "compliance-health",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 0,
      "y": 0
    },
    {
      id: "assurance-health",
      component: AssuranceHealthWidget,
      props: {},
      "h": 3,
      "i": "assurance-health",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 6,
      "y": 9
    },
    {
      id: "upcoming-tasks",
      component: UpcomingTasksWidgetMediumTall,
      props: {},
      "h": 3,
      "i": "upcoming-tasks",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 9,
      "y": 0
    },
    {
      id: "overdue-tasks",
      component: OverdueTasksWidgetMediumTall,
      props: {},
      "h": 3,
      "i": "overdue-tasks",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 0,
      "y": 3
    },
    {
      id: "data-storage-map",
      component: DataStorageMapWidget,
      props: {},
      "h": 4,
      "i": "data-storage-map",
      "moved": false,
      "static": false,
      "w": 6,
      "x": 3,
      "y": 0
    },
    {
      id: "supply-chain-risks",
      component: SupplyChainRisksChartWidget,
      props: {},
      "h": 3,
      "i": "supply-chain-risks",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 9,
      "y": 3
    },
    {
      id: "data-flow-diagram",
      component: DataFlowDiagram,
      props: {},
      "h": 5,
      "i": "data-flow-diagram",
      "moved": false,
      "static": false,
      "w": 6,
      "x": 3,
      "y": 4
    },
    {
      id: "task-assignment",
      component: TaskAssignmentListWidget,
      props: {},
      "h": 3,
      "i": "task-assignment",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 0,
      "y": 9
    },
    {
      id: "overdue-counter",
      component: OverdueTasksCounterWidget,
      props: {},
      "h": 3,
      "i": "overdue-counter",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 0,
      "y": 6
    },
    {
      id: "on-time-performance",
      component: OnTimePerformanceWidget,
      props: {},
      "h": 3,
      "i": "on-time-performance",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 9,
      "y": 9
    },
    {
      id: "supplier-count",
      component: TotalSupplierCountWidget,
      props: {},
      "h": 3,
      "i": "supplier-count",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 9,
      "y": 6
    },
    {
      id: "docs-requires-attention",
      component: SupportingDocsRequiresAttentionWidget,
      props: {},
      "h": 3,
      "i": "docs-requires-attention",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 3,
      "y": 9
    },
    {
      id: "corrective-actions-summary",
      component: CorrectiveActionsSummaryWidget,
      props: {},
      "h": 3,
      "i": "corrective-actions-summary",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 0,
      "y": 12
    },
    {
      id: "corrective-actions-list",
      component: CorrectiveActionsListWidget,
      props: {},
      "h": 3,
      "i": "corrective-actions-list",
      "moved": false,
      "static": false,
      "w": 3,
      "x": 3,
      "y": 12
    }
];


export { PA_dashboardConfig };
export default dashboardConfig;
